<h2 mat-dialog-title>{{ isEdit ? 'Editar cupón' : 'Nuevo cupón' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="coupon-form">

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Código</mat-label>
        <input matInput formControlName="code" maxlength="40" placeholder="ej: BIENVENIDA20" />
        <mat-error *ngIf="form.get('code')?.hasError('required')">El código es requerido</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Descripción</mat-label>
        <textarea matInput formControlName="description" rows="2" maxlength="255"></textarea>
        <mat-error *ngIf="form.get('description')?.hasError('required')">La descripción es requerida</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row two-cols">
      <mat-form-field appearance="outline">
        <mat-label>Tipo de descuento</mat-label>
        <mat-select formControlName="discountType">
          <mat-option *ngFor="let type of discountTypes" [value]="type.value">{{ type.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('discountType')?.hasError('required')">El tipo es requerido</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>{{ isPercentage ? 'Porcentaje de descuento' : 'Monto del descuento (COP)' }}</mat-label>
        <input matInput type="number" formControlName="amount" min="0" [max]="isPercentage ? 100 : null" />
        <span matTextSuffix *ngIf="isPercentage">%</span>
        <mat-error *ngIf="form.get('amount')?.hasError('required')">El valor es requerido</mat-error>
        <mat-error *ngIf="form.get('amount')?.hasError('min')">El valor debe ser mayor a 0</mat-error>
        <mat-error *ngIf="form.get('amount')?.hasError('max')">El porcentaje no puede superar 100%</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row" *ngIf="isPercentage">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Tope del descuento en COP</mat-label>
        <input matInput type="number" formControlName="maxDiscountValue" min="0" />
        <mat-hint>Vacío = sin tope. Aplica solo a descuentos por porcentaje</mat-hint>
      </mat-form-field>
    </div>

    <div class="form-row two-cols">
      <mat-form-field appearance="outline">
        <mat-label>Máx. redenciones totales</mat-label>
        <input matInput type="number" formControlName="maxRedemptionsTotal" min="1" />
        <mat-hint>Vacío = ilimitado</mat-hint>
        <mat-error *ngIf="form.get('maxRedemptionsTotal')?.hasError('min')">Debe ser mayor o igual a 1</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Máx. redenciones por usuario</mat-label>
        <input matInput type="number" formControlName="maxRedemptionsPerUser" min="1" />
        <mat-error *ngIf="form.get('maxRedemptionsPerUser')?.hasError('required')">Requerido</mat-error>
        <mat-error *ngIf="form.get('maxRedemptionsPerUser')?.hasError('min')">Debe ser mayor o igual a 1</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Valor mínimo del servicio (COP)</mat-label>
        <input matInput type="number" formControlName="minServiceValue" min="0" />
        <mat-hint>Vacío = sin mínimo</mat-hint>
      </mat-form-field>
    </div>

    <div class="form-row two-cols">
      <mat-form-field appearance="outline">
        <mat-label>Categoría</mat-label>
        <mat-select formControlName="categoryId">
          <mat-option [value]="null">Todas las categorías</mat-option>
          <mat-option *ngFor="let category of categories" [value]="category.categoryId">
            {{ category.categoryName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Subcategoría</mat-label>
        <mat-select formControlName="subcategoryId" [disabled]="!subcategories.length">
          <mat-option [value]="null">Todas las subcategorías</mat-option>
          <mat-option *ngFor="let sub of subcategories" [value]="sub.subcategoryId">
            {{ sub.subcategoryName }}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="!subcategories.length">Selecciona una categoría para ver sus subcategorías</mat-hint>
      </mat-form-field>
    </div>

    <div class="form-row two-cols">
      <mat-form-field appearance="outline">
        <mat-label>Vigente desde</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="validFrom" />
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Vigente hasta</mat-label>
        <input matInput [matDatepicker]="untilPicker" formControlName="validUntil" />
        <mat-datepicker-toggle matIconSuffix [for]="untilPicker"></mat-datepicker-toggle>
        <mat-datepicker #untilPicker></mat-datepicker>
        <mat-error *ngIf="form.get('validUntil')?.hasError('dateRange')">
          La fecha final debe ser posterior a la fecha inicial
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-row checkboxes">
      <mat-checkbox formControlName="firstJobOnly">
        Solo primer trabajo del usuario
      </mat-checkbox>
      <mat-checkbox formControlName="isStackable">
        Acumulable con otras promociones
      </mat-checkbox>
    </div>

    <div class="form-row auto-apply-row">
      <mat-slide-toggle formControlName="applyAutomatically">
        Aplicación automática
      </mat-slide-toggle>
      <span class="auto-apply-hint">
        Se aplica solo a todos los usuarios elegibles, sin digitar código. Un código manual lo reemplaza.
      </span>
    </div>

    <div class="form-row" *ngIf="isEdit">
      <mat-checkbox formControlName="isActive">Cupón habilitado</mat-checkbox>
    </div>

    <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()">Guardar</button>
</mat-dialog-actions>
